import styled, { css } from 'styled-components'

import { HeadingProps } from '.'

export const Wrapper = styled.h2<HeadingProps>`
  ${({ theme, color, size, weight, requiredColor, fontFamily }) => css`
    font-family: ${fontFamily === 'primary'
      ? theme.ds.typography.fontFamily
      : theme.ds.typography.fontFamilySecondary};
    color: ${theme.ds.colors?.[color!]};
    font-weight: ${theme.ds.typography.weight?.[weight!]};
    font-size: ${theme.ds.typography.size?.[size!]};
    line-height: ${theme.ds.typography.lineHeight.medium};

    span {
      color: ${theme.ds.colors[requiredColor!]};
    }
  `}

  ${({ flexStart }) =>
    flexStart &&
    css`
      display: flex;
      align-self: flex-start;
    `}
`
